import { NetworkStatus, useLazyQuery } from '@apollo/client';
import { getLabClientsTemplate, getSuppliersTemplate } from 'apollo/templates/client-directory';
import { ClientType, LabClient } from 'models/client-directory';
import { Dispatch, SetStateAction, useState } from 'react';
import { useDenthubErrorBoundary } from 'components/shared/denthub-error-boundary/denthub-error-boundary-context';

export const useLabClients = (setLabClients: Dispatch<SetStateAction<LabClient[]>>, clientType: ClientType) => {
    const { showBoundary } = useDenthubErrorBoundary();
    const [lastOffset, setLastOffset] = useState(0);
    const template = clientType === ClientType.SUPPLIER ? getSuppliersTemplate : getLabClientsTemplate;
    const [getLabClients, { loading, fetchMore, refetch, networkStatus }] = useLazyQuery(template, {
        notifyOnNetworkStatusChange: true,
        fetchPolicy: 'network-only',
        ...(clientType === ClientType.SUPPLIER
            ? {
                  onCompleted: ({ suppliers }) => {
                      setLabClients(suppliers || []);
                      setLastOffset(suppliers.length);
                  },
              }
            : {
                  onCompleted: ({ labClients }) => {
                      setLabClients(labClients || []);
                      setLastOffset(labClients.length);
                  },
              }),
        onError(error) {
            showBoundary(error);
        },
    });

    const fetchMoreLabClients = () => {
        fetchMore({
            variables: {
                offset: lastOffset,
            },
        });
    };

    return {
        getLabClients,
        fetchMoreLabClients,
        refetchLabClients: refetch,
        isLabClientListLoading: loading && networkStatus !== NetworkStatus.fetchMore,
    };
};
